<section *ngIf="!tokenValid">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'umustlogin' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/login">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'login' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'false'">
    <div class="rbt-conatct-area bg-gradient-11 rbt-section-gap">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title text-center mb--60">
                        <h2 class="title">{{'noAuth' | translate}}</h2>
                        <br><br>
                        <div>
                            <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/home">
                                <span class="icon-reverse-wrapper">
                                    <span class="btn-text">{{'home' | translate}}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section *ngIf="tokenValid && isTeacher === 'true'">
    <div class="rbt-dashboard-area rbt-section-gapBottom" style="margin: 50px 0;">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <!-- Start Dashboard Top  -->
                    <div class="rbt-dashboard-content-wrapper">
                        <div class="tutor-bg-photo bg_image bg_image--22 height-350"></div>
                        <!-- Start Tutor Information  -->
                        <div class="rbt-tutor-information">
                            <div class="rbt-tutor-information-left">
                                <div class="thumbnail rbt-avatars size-lg">
                                    <img style="aspect-ratio: 1 / 1;" *ngIf="this.teacher.profileImg != null" [src]="this.baseService.appUrl + this.teacher.profileImg" onerror="this.onerror=null;this.src='../../../assets/images/team/avatar.jpg';" alt="Instructor">
                                    <img style="aspect-ratio: 1 / 1;" *ngIf="this.teacher.profileImg === null" src="../../../assets/images/team/avatar.jpg" alt="Instructor">
                                </div>
                                <div class="tutor-content">
                                    <h5 class="title">{{this.userFullName}}</h5>
                                </div>
                            </div>
                            <div class="rbt-tutor-information-right">
                                <button type="submit" class="rbt-btn btn-gradient hover-transform-none" routerLink="/create-course/add/0">
                                    <span class="icon-reverse-wrapper">
                                        <span class="btn-text">{{'Create a New Course' | translate}}</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <!-- End Tutor Information  -->
                    </div>
                    <!-- End Dashboard Top  -->

                    <div class="row g-5">
                        <div class="col-lg-3">
                            <!-- Start Dashboard Sidebar  -->
                            <div class="rbt-default-sidebar sticky-top rbt-shadow-box rbt-gradient-border">
                                <div class="inner">
                                    <div class="content-item-content">

                                        <div class="rbt-default-sidebar-wrapper">
                                            <div class="section-title mb--20">
                                                <h6 class="rbt-title-style-2">{{'Welcome' | translate}} {{this.userFullName}}</h6>
                                            </div>
                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewProfile(this.teacherId)"><i class="feather-user"></i><span>{{'View Profile' | translate}}</span></a></li>
                                                    <li><a (click)="viewCourses(this.teacherId)"><i class="feather-monitor"></i><span>{{'MyCourses' | translate}}</span></a></li>
                                                    <li><a (click)="ViewPayments(this.teacherId)"><i class="feather-dollar-sign"></i><span>{{'payments' | translate}}</span></a></li>
                                                </ul>
                                            </nav>

                                            <div class="section-title mt--40 mb--20">
                                                <h6 class="rbt-title-style-2">{{'UserSettings' | translate}}</h6>
                                            </div>

                                            <nav class="mainmenu-nav">
                                                <ul class="dashboard-mainmenu rbt-default-sidebar-list">
                                                    <li><a (click)="viewSettings(this.teacherId)"><i class="feather-settings"></i><span>{{'Settings' | translate}}</span></a></li>
                                                   
                                                </ul>
                                            </nav>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- End Dashboard Sidebar  -->
                        </div>

                        <div class="col-lg-9">
                            <div class="rbt-dashboard-content bg-color-white rbt-shadow-box">
                                <div class="content">

                                    <div class="section-title">
                                        <h4 class="rbt-title-style-3">{{'Courses' | translate}}
                                        </h4>
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="filter-select rbt-modern-select">
                                                    <span class="select-label d-block">{{'Category' | translate}}</span>
                                                    <div class="rbt-modern-select bg-transparent height-45 w-100 mb--10">
                                                        <dx-select-box id="categoryId" name="categoryId"  searchMode="contains" [showDropDownButton]="true" [dataSource]="categories"
                                                        [rtlEnabled]="this.baseService.isRTL" class="borderStyle" placeholder="" [showClearButton]="true" placeholder="{{'catSearch' | translate}}"
                                                        displayExpr="nameAr" valueExpr="id" ngModel #categoryId="ngModel" [searchEnabled]="true" (onSelectionChanged)="getCategoryId($event)">
                                                        </dx-select-box>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <br>
                                    </div>

                                    <div *ngIf="noCoursesForThisTeacherSection">
                                        <div class="noCoursesMsg" style="text-align: center;">
                                            <h3>{{'noCoursesMsg' | translate}}</h3>
                                        </div>
                                    </div>

                                    <div class="row g-5" *ngIf="!noCoursesForThisTeacherSection">
                                        <div class="col-lg-4 col-md-6 col-12" *ngFor="let course of courses | paginate: { itemsPerPage: 6, currentPage: p }">
                                            <div class="rbt-card variation-01 rbt-hover"  >
                                                <div class="rbt-card-img">
                                                    <a>
                                                        <img style="max-height: 160px !important;min-height: 160px;" [src]="this.baseService.appUrl + course.thumbNail" onerror=" this.onerror=null;this.src='assets/images/bg/bg-g100.webp';" alt="Card image">
                                                    </a>
                                                </div>
                                                <div class="rbt-card-body">

                                                    <h4 class="rbt-card-title" style="font-size: 20px; cursor: pointer;"><a (click)="viewCourseDetails(course.id)">{{course.courseNameAr}}</a>
                                                    </h4>
                                                    <ul class="rbt-meta">
                                                        <li>{{course.lessons}} {{'Lessons' | translate}}</li>
                                                        <li class="enrolledStudents" (click)="showEnrolledStudents(course.id)" data-bs-toggle="modal" data-bs-target="#studentsModal">{{course.studentsEnrolledNo}} {{'StudentsEnroll' | translate}}</li>
                                                    </ul>


                                                    <div class="rbt-card-bottom">

                                                        <a class="rbt-btn-link" *ngIf="course.studentsEnrolledNo === 0" (click)="editCourse(course.id)"><i class="feather-edit"></i> {{'edit' | translate}}</a>
                                                        <a class="rbt-btn-link" *ngIf="course.studentsEnrolledNo === 0" (click)="deleteCourse(course.id)"><i class="feather-trash"></i> {{'delete' | translate}}</a>
                                                    </div>

                                                    <div style="    text-align: center;
                                                    padding-top: 20px;
                                                    border-top: 1px solid #DDD;
                                                    margin-top: 20px;">
                                                        <a class="rbt-btn-link" (click)="goToLMS(course.id)"><i class="feather-monitor"></i> {{'go' | translate}}</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-12 mt--60">
                                            <pagination-controls 
                                            class="rbt-pagination" 
                                            (pageChange)="p = $event"
                                            previousLabel=""
                                            nextLabel=""
                                            ></pagination-controls>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="rbt-team-modal modal fade rbt-modal-default" id="studentsModal" tabindex="-1" role="dialog" aria-labelledby="studentsModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 800px;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="rbt-round-btn" data-bs-dismiss="modal" aria-label="Close" (click)="clearEnrollments()">
                                <i class="feather-x"></i>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="inner">
                                <div class="noEnrollments" *ngIf="noEnrollYet">
                                    <h4>{{'noEnrollments' | translate}}</h4>
                                </div>
                                <div *ngIf="!noEnrollYet">
                                    <ul>
                                        <li *ngFor="let stud of enrollments">
                                            <h5>{{stud.name}} {{stud.surname}}</h5>
                                        </li>
                                    </ul>
                                </div>
                                <div class="top-circle-shape"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
